import { PageItemApi } from 'api/PageItemApi';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { QuestionAbstractMapper } from 'mapper/QuestionAbstractMapper';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { PageItemKind } from 'model/PageItemKind';
import { QuestionConsent } from 'model/QuestionConsent';

export class QuestionConsentMapper
  implements PageItemKindMapper<QuestionConsent, PageItemApi.QuestionConsentEntry>
{
  constructor() {}

  serialize(model: QuestionConsent): PageItemApi.QuestionConsentEntry {
    return {
      ...QuestionAbstractMapper.serialize(model),
      optionNo: model.optionNo,
      optionYes: model.optionYes,
      logic: null,
      kind: PageItemKind.QuestionConsent,
    };
  }

  deserialize({
    optionYes,
    optionNo,
    ...entry
  }: PageItemApi.QuestionConsentEntry): QuestionConsent {
    return {
      ...QuestionAbstractMapper.deserializeShape(entry),
      optionYes,
      optionNo,
      locale: entry.locale,
    };
  }

  supportsSerialize(model: PageItemModel): model is QuestionConsent {
    return model.kind === PageItemKind.QuestionConsent;
  }

  supportsDeserialize(
    entry: PageItemApi.ImageWidgetEntry,
  ): entry is PageItemApi.QuestionConsentEntry {
    return entry.kind === PageItemKind.QuestionConsent;
  }
}
